/* src/app/app.component.scss */
.header {
  height: 10px;
  width: 100%;
  height: 23px;
  z-index: 10000;
}
/*# sourceMappingURL=app.component.css.map */
